var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-top": "-20px" } },
    [
      _c("goldDetailTable", {
        attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
        on: {
          "update:goldData": function($event) {
            _vm.goldData = $event
          },
          "update:gold-data": function($event) {
            _vm.goldData = $event
          }
        }
      }),
      _vm._v(" "),
      _c("goldDetailFlowRecord", {
        attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
        on: {
          "update:goldData": function($event) {
            _vm.goldData = $event
          },
          "update:gold-data": function($event) {
            _vm.goldData = $event
          }
        }
      }),
      _vm._v(" "),
      _c("goldDetailOriginInfo", {
        staticStyle: { "margin-top": "16px" },
        attrs: { parentData: _vm.parentData, goldData: _vm.goldData },
        on: {
          "update:goldData": function($event) {
            _vm.goldData = $event
          },
          "update:gold-data": function($event) {
            _vm.goldData = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceCenter" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn-blue-line",
              staticStyle: { margin: "30px 0", width: "100px" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aec7fbd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aec7fbd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/financing-gold-detail-comp.vue
// module id = aB3b
// module chunks = 1